import { getElementWidth } from "./get-element-width";

export function calculateMinWidth(collection, start, end, margin) {
    let minWidth = 0;

    for (let i = start; i < end; i++) {
        minWidth += getElementWidth(collection[i], margin);
    }

    return minWidth;
}
